import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { HydraCollection } from '../hydra/hydra-collection';

@Injectable({
  providedIn: 'root'
})
export class FeatureApiService extends ApiService {
  readonly resourcePath = 'features';

  list(filters: Record<string, string> = {}): Observable<HydraCollection<any>> {
    return this.restList<any>(filters);
  }

  get(id: string): Observable<any> {
    return this.restRead<any>(id);
  }
}
